"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowTransformerValidator = void 0;
var types_1 = require("../types");
var RowTransformerValidator = /*#__PURE__*/function () {
  function RowTransformerValidator() {
    _classCallCheck(this, RowTransformerValidator);
    _defineProperty(this, "_rowTransform", null);
    _defineProperty(this, "_rowValidator", null);
  }
  return _createClass(RowTransformerValidator, [{
    key: "rowTransform",
    set: function set(transformFunction) {
      if (typeof transformFunction !== 'function') {
        throw new TypeError('The transform should be a function');
      }
      this._rowTransform = RowTransformerValidator.createTransform(transformFunction);
    }
  }, {
    key: "rowValidator",
    set: function set(validateFunction) {
      if (typeof validateFunction !== 'function') {
        throw new TypeError('The validate should be a function');
      }
      this._rowValidator = RowTransformerValidator.createValidator(validateFunction);
    }
  }, {
    key: "transformAndValidate",
    value: function transformAndValidate(row, cb) {
      var _this = this;
      return this.callTransformer(row, function (transformErr, transformedRow) {
        if (transformErr) {
          return cb(transformErr);
        }
        if (!transformedRow) {
          return cb(null, {
            row: null,
            isValid: true
          });
        }
        return _this.callValidator(transformedRow, function (validateErr, validationResult) {
          if (validateErr) {
            return cb(validateErr);
          }
          if (validationResult && !validationResult.isValid) {
            return cb(null, {
              row: transformedRow,
              isValid: false,
              reason: validationResult.reason
            });
          }
          return cb(null, {
            row: transformedRow,
            isValid: true
          });
        });
      });
    }
  }, {
    key: "callTransformer",
    value: function callTransformer(row, cb) {
      if (!this._rowTransform) {
        return cb(null, row);
      }
      return this._rowTransform(row, cb);
    }
  }, {
    key: "callValidator",
    value: function callValidator(row, cb) {
      if (!this._rowValidator) {
        return cb(null, {
          row: row,
          isValid: true
        });
      }
      return this._rowValidator(row, cb);
    }
  }], [{
    key: "createTransform",
    value: function createTransform(transformFunction) {
      if ((0, types_1.isSyncTransform)(transformFunction)) {
        return function (row, cb) {
          var transformed = null;
          try {
            transformed = transformFunction(row);
          } catch (e) {
            return cb(e);
          }
          return cb(null, transformed);
        };
      }
      return transformFunction;
    }
  }, {
    key: "createValidator",
    value: function createValidator(validateFunction) {
      if ((0, types_1.isSyncValidate)(validateFunction)) {
        return function (row, cb) {
          cb(null, {
            row: row,
            isValid: validateFunction(row)
          });
        };
      }
      return function (row, cb) {
        validateFunction(row, function (err, isValid, reason) {
          if (err) {
            return cb(err);
          }
          if (isValid) {
            return cb(null, {
              row: row,
              isValid: isValid,
              reason: reason
            });
          }
          return cb(null, {
            row: row,
            isValid: false,
            reason: reason
          });
        });
      };
    }
  }]);
}();
exports.RowTransformerValidator = RowTransformerValidator;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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